// extracted by mini-css-extract-plugin
export default {"homecontainer":"home_homecontainer__VrKQF"};